<div class="official-website-home-page">
  <div class="header-title">
    <h1><span style="display: flex;">e<span style="color: red;">X</span>tra<span style="color: red;">.</span></span>
    </h1>
    <p>面向维修站的一站式积分平台</p>
  </div>
  <div class="business-content">
    <h2 class="content-title">马上注册！</h2>
    <div class="mx:flex sm:block">
      <div class="business-left contact-link">
        <p>博世易加网 eXtra. 是博世面向维修站客户的一站式积分平台，意在与行业平台和经销商合作伙伴共同向维修站提供高品质的产品，超值的服务与便捷的数字化解决方案。
          易加网提供的服务包括品牌礼品，展示物料兑换；在线和线下的培训课程；博世配件防伪验证查询；博世电子目录查询以及丰富多彩的互动活动等。
        </p>
        <a href="https://www.bosch-extra.com.cn/home" target="_blank" class="text-[#03619A]">
          马上注册
          <svg-icon [iconName]="'official-website/externallink.svg'" [isUrl]="false" [size]="30"></svg-icon>
          <!-- <img src="assets/official-website/externallink.svg" alt="export" style="width: 1.2em"> -->
        </a>
        <p>
          手机扫一扫即刻注册
        </p>
        <img src="assets/official-website/code.jpg" alt="code">
      </div>
      <div class="business-right">
        <img src="assets/official-website/extra-teaser.png" alt="extra-teaser">
      </div>
    </div>
  </div>
</div>